import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { CategoryType } from '../category-type';

export class CategoryTypeBuilder {
  static fromJson(json) {
    return (json)
      ? new CategoryType(
        parseNumber(json.code),
        json.name
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(CategoryTypeBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/category-type.builder.ts